import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, patchAPIwithToken } from '../utils/fetchApi';

export interface ApiSaleOrganization {
  id: number;
  name: string;
  description?: string;
  status: number | string | boolean;
  is_active?: number;
  createdBy?: string;
  created_by?: string;
  createdOn?: string;
  createdAt?: string;
  created_at?: string;
  updatedAt?: string;
  updated_at?: string;
}

export interface GetSaleOrganizationsResponse {
  success?: boolean;
  status?: string | number;
  message?: string;
  data?: ApiSaleOrganization[];
  saleOrganizations?: ApiSaleOrganization[];
  organizations?: ApiSaleOrganization[];
}

export interface CreateSaleOrganizationPayload {
  name: string;
  description?: string;
  status?: number;
}

export interface UpdateSaleOrganizationPayload {
  id: number;
  name?: string;
  description?: string;
  status?: number;
}

export async function getSaleOrganizationsList(): Promise<GetSaleOrganizationsResponse> {
  return getAPIwithToken<GetSaleOrganizationsResponse>(ENDPOINTS.SALE_ORGANIZATIONS);
}

export async function createSaleOrganization(
  payload: CreateSaleOrganizationPayload
): Promise<any> {
  return postAPIwithToken(ENDPOINTS.SALE_ORGANIZATIONS, payload);
}

export async function updateSaleOrganization(
  payload: UpdateSaleOrganizationPayload
): Promise<any> {
  return patchAPIwithToken(ENDPOINTS.SALE_ORGANIZATIONS, payload);
}
